export let advertisement=[
    {
        id:1,
        img:'/skydome images/paolo-giubilato-ZwKCWVFdrcs-unsplash.jpg',
        newPrice:'294,000',
        oldPrice:'555,000'
    },
    {
        id:2,
        img:'/skydome images/c12-laptop-img2.jpeg',
        newPrice:'194,000',
        oldPrice:'345,000'
    },
    {
        id:3,
        img:'/skydome images/c3-shoe-img.png',
        newPrice:'10,000',
        oldPrice:'25,000'
    },
    {
        id:4,
        img:'/skydome images/c14-shoe-img.png',
        newPrice:'11,000',
        oldPrice:'27,000'
    },
    {
        id:5,
        img:'/skydome images/c11-shoe-img.jpeg',
        newPrice:'20,000',
        oldPrice:'29,000'
    },
    {
        id:6,
        img:'/skydome images/c20-earbuds-img.jpeg',
        newPrice:'4,000',
        oldPrice:'8,000'
    },
    {
        id:7,
        img:'/skydome images/c21-gascooker-img.png',
        newPrice:'41,000',
        oldPrice:'95,000'
    },
    {
        id:8,
        img:'/skydome images/c24-mattress-img.png',
        newPrice:'40,000',
        oldPrice:'92,000'
    },
    {
        id:9,
        img:'/skydome images/c24-shoe-img.png',
        newPrice:'11,000',
        oldPrice:'50,000'
    },
]